import React, { ReactNode } from "react";
import cx from "classnames";
import st from "./sliderText.module.scss";

type Props = {
  smallHeader: string;
  largeHeader: ReactNode;
};

const SliderText = (props: Props) => {
  return (
    <div className={st.text}>
      <h3 className={cx(st.heading, st.headingSmall)}>{props.smallHeader}</h3>
      <h2 className={cx(st.heading, st.headingLarge)}>{props.largeHeader}</h2>
    </div>
  );
};

export default SliderText;
